<template lang="pug">
  v-card(width=450, elevation=4, name="inn-organisation-card")
    v-card-title(class="mb-4")
      v-layout(row justify-center)
        v-flex(xs12)
          h5(class="headline text-xs-center font-weight-bold") {{$t('StartPage.registerBlock.loginSystem')}}
          p(class="subheader text-xs-center mb-0 grey--text text--darken-2") {{$t('StartPage.registerBlock.enterInn')}}
    v-card-text
      v-layout(row justify-center)
        v-flex(xs10)
          v-form(ref="form" @submit.prevent="nextStep" lazy-validation)
            v-text-field(
              class="mb-2",
              :rules="innOrganisationRules",
              outline,
              single-line,
              v-model="innOrganisation",
              mask="##############",
              counter="14",
              ref="innOrganisation",
              name="innOrganisation",
              :label="$t('StartPage.registerBlock.innOrganization')",
              autocomplete="off",
              clearable,
              validate-on-blur)
            v-text-field(
              :rules="okpoRules",
              outline,
              single-line,
              v-model="okpo",
              name="okpo",
              ref="okpo",
              mask="########",
              counter="8",
              :placeholder="$t('StartPage.registerBlock.okpoOrganization')",
              autocomplete="off",
              clearable,
              validate-on-blur,
              style="marginBottom: 80px")
            div(:style="isError ? `color:#ff0000` : `color:#333`", id="responseText") {{ responseText }}
            v-btn(
              id="innOrganisation-btn",
              :loading="loading",
              large,
              type="submit",
              color="primary").mb-4
              span.pl-2 {{$t('StartPage.registerBlock.btnForward')}}
              v-icon keyboard_arrow_right
</template>

<script>
export default {
  name: 'Inn',
  data() {
    return {
      innOrganisationRules: [
        v => !!v || this.$t('StartPage.registerBlock.errorEnterInn'),
        v => (v && v.length > 13) || this.$t('StartPage.registerBlock.errorInnOrganization')
      ],
      okpoRules: [v => !!v || this.$t('StartPage.registerBlock.errorEnterOkpo')],
      isDisableBtn: true,
      responseText: '',
      isError: false
    }
  },
  mounted() {
    // this.$refs.innOrganisation.$refs.input.focus() Убрал фокус с input ИНН
  },
  watch: {
    innOrganisation(val) {
      this.clearErrors()
      let okpo = this.$store.state.auth.okpo
      if (val && val.length === 14 && okpo.length === 8) {
        this.getOrganisationRequest()
      }
      if (val.length) {
        this.$refs.innOrganisation.$el.getElementsByClassName('v-input__slot')[0].style.border = '2px solid #007AFF'
      } else {
        this.$refs.innOrganisation.$el.getElementsByClassName('v-input__slot')[0].style.border = 'solid 1px #8e8e93'
      }
    },
    okpo(val) {
      this.clearErrors()
      let inn = this.$store.state.auth.innOrganisation
      this.responseText = ''
      if (val && inn.length === 14 && val.length === 8) {
        this.getOrganisationRequest()
      }
      if (val.length) this.$refs.okpo.$el.getElementsByClassName('v-input__slot')[0].style.border = '2px solid #007AFF'
      else this.$refs.okpo.$el.getElementsByClassName('v-input__slot')[0].style.border = 'solid 1px #8e8e93'
    }
  },
  computed: {
    loading() {
      return this.$store.state.auth.loading.verifyOrgName
    },
    innOrganisation: {
      get() {
        return this.$store.state.auth.innOrganisation
      },
      set(val) {
        this.$store.commit('SET_INN_ORGANISATION_VALUE', val)
      }
    },
    okpo: {
      get() {
        return this.$store.state.auth.okpo
      },
      set(val) {
        this.$store.commit('SET_OKPO_VALUE', val)
      }
    }
  },
  methods: {
    clearErrors() {
      this.$store.commit('CLEAR_ORGANISATION_NAME_ERROR', '')
      this.responseText = ''
    },
    getOrganisationRequest() {
      this.$store.dispatch('GET_ORGANISATION_NAME').then(() => {
        let state = this.$store.state.auth
        if (state.errors.getOrganisationName) {
          this.responseText = state.errors.getOrganisationName
          this.isDisableBtn = true
          this.isError = true
        } else {
          this.responseText = state.response.getOrganisationName.userName
          this.isDisableBtn = false
          this.isError = false
        }
      })
    },
    nextStep() {
      if (this.$refs.form.validate()) {
        this.$emit('next-step', 'showInnPersonalForm')
        this.responseText = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.v-card {
  padding-top: 40px;
  border-radius: 6px;
  &__text {
    .v-form {
      text-align: center;
      position: relative;
      .v-btn {
        border-radius: 25px;
      }
      #responseText {
        position: absolute;
        bottom: 110px;
        left: 0;
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/common/InnOrganisation.vue